import { useEffect, useState } from "react";

import { getSharedTalent } from "../services/sharedTalentService";

export function useSharedTalent(talentTag) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const controller = new AbortController();

    const load = async () => {
      setLoading(true);
      setError("");
      setProfile(null);

      try {
        const response = await getSharedTalent(talentTag, controller.signal);

        if (controller.signal.aborted) return;

        if (response?.data?.success === false) {
          throw new Error(response.data.message || "Unable to load Talent ID.");
        }

        setProfile(response?.data?.profile ?? null);
      } catch (err) {
        if (controller.signal.aborted) return;

        setError(
          err?.response?.data?.message ||
            err?.message ||
            "Unable to load Talent ID.",
        );
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    if (talentTag) {
      load();
    } else {
      setProfile(null);
      setError("Invalid Talent ID.");
      setLoading(false);
    }

    return () => controller.abort();
  }, [talentTag, refreshKey]);

  return {
    profile,
    sports: profile?.sports || [],
    experiences: profile?.experiences || [],
    achievements: profile?.achievements || [],
    media: profile?.media || [],
    loading,
    error,
    refresh: () => setRefreshKey((value) => value + 1),
  };
}
